import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableActions from "./table-actions";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { Box, Button, Stack, TablePagination } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetLegalCapitalList } from "src/api/settings/capital";
import { oneBranchHasPermission } from "src/utils";
import { SettingsPermissions } from "src/constants/permissions";
import AddIcon from "@mui/icons-material/Add";
import AddEditLegalCapital from "../add-edit-capital";

const LegalCapitalTable = () => {
  const { t } = useTranslation("settings");
  const { t: generalT } = useTranslation("general");
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [openCapital, setOpenCapital] = useState(false);
  const tableHeadText = [
    generalT("reference"),
    generalT("type"),
    t("capitalAmount"),
    t("paidAmount"),
    generalT("date"),

    generalT("actions"),
  ];

  // apis
  const { data, isLoading, refetch } = useGetLegalCapitalList({
    page: pageNumber + 1,
  });

  const handleOpenCapital = () => setOpenCapital(true);
  const handleCloseCapital = () => setOpenCapital(false);

  const isEmptyDataArr = data?.data.length === 0;

  //permissions
  const addPermission = oneBranchHasPermission(SettingsPermissions.addCapital);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage);
  };

  useEffect(() => {
    if (data) {
      setTotal(data.meta.total);
    }
  }, [data]);

  return (
    <Box>
      <Stack
        direction={"row"}
        flexWrap={"wrap"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        mb={3}
      >
        <Stack direction={"row"} flexWrap={"wrap"} gap={2}>
          {addPermission && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpenCapital}
            >
              {t("addLegalCapital")}
            </Button>
          )}
        </Stack>
      </Stack>
      <TableContainer component={Paper} variant="outlined">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {tableHeadText.map((item) => (
                <TableCell
                  key={item}
                  align="center"
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "18px",
                    color: "#475467",
                    bgcolor: "#F9FAFB",
                  }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableLoadingSkeleton rowsLength={8} cellsLength={6} />
          ) : (
            <TableBody>
              {data?.data.map((row: any) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{row.reference}</TableCell>
                  <TableCell align="center">{row.type}</TableCell>
                  <TableCell align="center">{row.capital_amount}</TableCell>
                  <TableCell align="center">{row.paid_amount}</TableCell>
                  <TableCell align="center">{row.date}</TableCell>

                  <TableCell align="center">
                    <TableActions row={row} refetch={refetch} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {isEmptyDataArr && <NoData />}
      </TableContainer>
      <TablePagination
        sx={{ mt: 1 }}
        rowsPerPageOptions={[20]}
        component="div"
        count={total}
        rowsPerPage={20}
        page={pageNumber}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />

      {openCapital && (
        <AddEditLegalCapital
          open={openCapital}
          handleClose={handleCloseCapital}
          refetch={refetch}
        />
      )}
    </Box>
  );
};
export default LegalCapitalTable;
